export default __webpack_public_path__ + "maps-overview-annotation-view-960-544fffd447a660e0de324b690f183180.webp";